<template>
  <div class="text-sm">
    <p class="mt-6">
      <b>2024.12.04</b> - Улучшения производительности и UI, изменения баланса...
    </p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>
        Баланс
        <ul>
          <li>- Уменьшено масштабирование срабатываний оружия Огненный/Ледяной/Грозовой/Плачущий/Ядовитый</li>
          <ul>
            <li class="pl-4">
              * урон Огненный: <code>30 + Уровень*6</code> -->
              <code>50 + Уровень*4</code>
            </li>
            <li class="pl-4">* прыжки Ледяной: <code>Уровень/5</code> --> <code>Уровень/7</code></li>
            <li class="pl-4">
              * урон Молния: <code>30 + Уровень*4</code> -->
              <code>50 + Уровень*2</code>
            </li>
            <li class="pl-4">
              * мощность Плачущий/Ядовитый: <code>10 + Уровень</code> -->
              <code>5 + Уровень/2.5</code>
            </li>
          </ul>
          <li>
            - Уменьшено масштабирование стоимости МС Призыв дворфа/Эльф/Фея с
            <code>Уровень*100</code> до <code>Уровень*50</code>
          </li>
          <li>
            - Увеличено масштабирование стоимости МС Молитва исцеления с
            <code>10 + Уровень*4</code> до <code>5 + Уровень*10</code>
          </li>
          <li>
            - Увеличено масштабирование стоимости ОД Поделиться маной с
            <code>25</code> до <code>45</code>
          </li>
        </ul>
      </li>
      <li>Уменьшен интервал пополнения Shopkeeper с 3 часов до 30 минут</li>
      <li>Увеличено количество PD, продаваемого за реальную валюту</li>
      <li>Исправлены Шипастая броня</li>
      <li>Исправлена математика Опыт, необходимого для уровней 50+ (извините, Mr. Gentle)</li>
      <li>Исправлена куча проблем с раскладкой UI, особенно для меньших разрешений</li>
      <li>
        Исправлена утечка памяти в отрисовке благословение, пара других утечек Пещеры, утечка
        Armory, и огромная утечка для всех в вебе при нажатии кнопки Refresh.
      </li>
    </ul>
  </div>
</template>
